module.exports = __webpack_public_path__ + "static/media/gallery-14.05ece9d9.jpeg";